<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="table__title_with-button">
            <h1>{{ title }}</h1>
          </div>
        </div>
      </div>
      <div>
        <div class="col-lg-12">
          <div class="panel panel-default">
            <FilterForm
              :custom-fields-list="filterFields"
              @search="searchRecords"
              @on-reset-filters="resetFilters"
              :disabled="notFound && !searchData"
            />
            <Preloader v-if="isLoadingNow && !notFound" />
            <div v-else-if="!isLoadingNow && !notFound" class="panel-body">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-hover table_with-image">
                  <thead>
                    <tr>
                      <th v-if="false" class="list__column">
                      </th>
                      <th
                        v-for="column in columns"
                        :key="column"
                        class="list__column"
                      >
                        <span
                          class="list__column_with-icon"
                          @click="changeListOrder(column)"
                        >
                          {{ column }}
                          <i v-if="column === orderColumn" :class="orderIconCss" />
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in filteredRecords"
                      :key="item.id"
                      @click="openExistedRecord(item.id)"
                    >
                      <td
                        v-if="false"
                        class="list__row"
                        @click.stop=""
                      >
                        <input
                          type="checkbox"
                          :value="item.id"
                          v-model="selectedIds"
                        />
                      </td>
                      <td v-for="row in rows" :key="row" class="list__row">
                        {{ getRow(item[row]) }}
                      </td>
                      <td
                        v-for="(field, objectName) in foreignKeyValues"
                        :key="objectName"
                        class="list__row"
                      >
                        {{ item[`${objectName}_id`][field] || '-' }}
                      </td>
                      <td
                        v-for="(field, link) in rowLinks"
                        :key="link"
                        class="list__row"
                      >
                        <router-link
                          v-if="item[`${link}_id`]"
                          :to="getRowLink(item, link)"
                          target="_blank"
                          @click.native.capture.stop
                        >
                          {{ item[`${link}_id`][field] }}
                        </router-link>
                        <span v-else>-</span>
                      </td>
                      <td v-if="imageSubfolder" class="list__row" @click.native.capture.stop>
                        <ImageRow :subfolder="imageSubfolder" :src="item.image_url" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="list__footer">
                <div>
                  <Pagination
                    :pages-counter="pagesCounter"
                    :current-page="currentPage"
                    @select="(page) => changePage(page, 'getAllRecords')"
                  />
                </div>
                <div class="table__buttons">
                  <button
                    v-if="checkVipRole()"
                    type="button"
                    class="btn btn-default btn-font btn-primary footer__button_add-operation"
                    @click="openAddForm"
                  >
                    {{ submitButtonText }}
                  </button>
                  <div v-if="false">
                    <ImportModal
                      v-if="importModalIsVisible"
                      @close="importModalIsVisible = false"
                    />
                    <button
                      type="button"
                      class="btn btn-primary button_excel-doc btn-default btn-font"
                      :disabled="isGenerating"
                      @click="importModalIsVisible = true"
                    >
                      <i class="fa fa-upload fa-fw"></i>
                      Импорт
                    </button>
                    <button
                      v-for="dataType in dataGenerationTypes"
                      :key="dataType.slug"
                      type="button"
                      class="btn btn-primary button_excel-doc btn-default btn-font"
                      :disabled="isGenerating"
                      @click="generateDocument(dataType.slug)"
                    >
                      <i class="fa fa-file fa-fw"></i>
                      {{ dataType.name }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="notFound && !isLoadingNow"
              class="table__content_empty-results"
            >
              <p class="">Ничего не найдено</p>
              <div v-if="checkVipRole()" class="body__button_add-first-row">
                <button
                  type="button"
                  class="results__text btn btn-success"
                  @click="openExistedRecord('new')"
                >
                  Добавить новую запись
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterForm from "@/_shared/features/table/FilterForm";
import Pagination from "@/_shared/components/ui/Pagination";
import Preloader from "@/_shared/components/ui/Preloader";
import ImageRow from "@/_shared/features/table/ImageRow";
import ImportModal from "@/_shared/components/modals/ImportModal";
import httpClient from "@/_shared/http-client";
import { dataService } from "@/_shared/api-services";
import {
  usePagination,
  useTableHelper,
  useOrderFilter,
  useRoleIdentifier,
  useNotification,
} from "@/_shared/mixins";
import { pagination, string } from "@/_shared/utils";
const { getPagesCounter } = pagination;
const { camelToSnakeCase } = string;
export default {
  mixins: [
    usePagination,
    useTableHelper,
    useOrderFilter,
    useRoleIdentifier,
    useNotification,
  ],
  components: {
    FilterForm,
    Pagination,
    ImageRow,
    Preloader,
    ImportModal,
  },
  props: {
    imageSubfolder: {
      type: String,
      default: null,
    },
    foreignKeyValues: {
      type: Object,
      default: null,
    },
    orderFields: {
      type: Object,
      required: true,
    },
    rowLinks: {
      type: Object,
      default: null,
    },
    linkSlug: {
      type: String,
      default: "providers",
    },
    filterFields: {
      type: Array,
      default() {
        return [];
      },
    },
    submitButtonText: {
      type: String,
      default: "Добавить запись",
    },
    tableName: {
      type: String,
      default: "providers",
    },
    title: {
      type: String,
      default: "Все записи",
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    rows: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isGenerating: false,
      selectedIds: [],
      searchData: [],
      searchingParams: null,
      isLoadingNow: true,
      records: [],
      filteredRecords: [],
      importModalIsVisible: false,
      notFound: false,
    };
  },
  watch: {
    "$route.fullPath": {
      async handler() {
        this.notFound = false;
        this.isLoadingNow = true;
        this.selectedIds = [];
        this.resetFilters();
        this.resetOrder();
      },
    },
  },
  computed: {
    dataGenerationTypes() {
      return [
        { name: 'Экспорт', slug: 'export' },
        { name: 'Шаблон импорта', slug: 'import' },
      ];
    },
    allowedForDataGeneration() {
      const allowedEntities = ["stationery"];
      return allowedEntities.includes(this.$route.name);
    },
  },
  methods: {
    async generateDocument(operation = 'import') {
      this.isGenerating = true;
      const text = 'Документ генерируется. Пожалуйста, подождите';
      this.showWarningNotification(text)
      const data = {
        entity: this.$route.name,
        ids: this.selectedIds,
        operation,
      };
      await dataService.generateDocument(data).then(() => {
        this.isGenerating = false;
      });
    },
    openAddForm() {
      this.$router.push(`/${this.linkSlug}/new`);
    },
    openExistedRecord(id) {
      const routeData = this.$router.resolve(`/${this.linkSlug}/${id}`);
      window.open(routeData.href, "_self");
    },
    async resetFilters() {
      this.notFound = false;
      this.isLoadingNow = true;
      this.searchingParams = null;
      this.searchData = [];
      this.records = await this.getAllRecords(1);
    },
    async changeListOrder(columnName) {
      this.toggleOrder(columnName);
      if (this.searchingParams) {
        return await this.searchRecords(this.searchData);
      }
      await this.getAllRecords(1);
    },
    prepareItems(filterName, filterItems) {
      filterName = camelToSnakeCase(filterName);
      if (filterName === "id") {
        return `filter=${filterName},sw,${filterItems}`;
      }
      if (filterName === "created_at" || filterName === "updated_at") {
        return filterItems.length > 1
          ? `filter=${filterName},bt,${filterItems[0]},${filterItems[1]}`
          : `filter=${filterName},sw,${filterItems[0]}`;
      } else {
        const booleanValues = ["1", "0"];
        if (booleanValues.includes(filterItems)) {
          return `filter=${filterName},cs,${+filterItems}`;
        }
        return `filter=${filterName},cs,${filterItems}`;
      }
    },
    async searchRecords(searchData) {
      this.notFound = false;
      this.isLoadingNow = true;
      if (searchData.length > 0) {
        let filter = [];
        searchData.forEach((item) => {
          for (let itemKey in item) {
            filter.push(this.prepareItems(itemKey, item[itemKey]));
          }
        });
        let searchingParams = filter.join("&");
        searchingParams = this.addOrderQueryParam(searchingParams);
        searchingParams = this.setJoins(searchingParams);
        this.searchingParams = searchingParams;
        this.searchData = searchData;
        searchingParams += `&page=1`;

        const url = `/generated/records/${this.tableName}?${searchingParams}`;
        const response = await httpClient.get(url);

        this.pagesCounter = getPagesCounter(response.data.results);
        this.currentPage = 1;
        this.filteredRecords = response.data.records;
        this.notFound = !this.filteredRecords.length > 0 || false;
        this.isLoadingNow = false;
      }
    },
    async getAllRecords(page = 1) {
      this.isLoadingNow = true;

      let url = `/generated/records/${this.tableName}?page=${page}`;
      url = this.addOrderQueryParam(url);
      url = this.setJoins(url);
      const response = await httpClient.get(url);
      this.redirectIfNotVip();
      this.filteredRecords = response.data.records;
      this.notFound = !!(this.filteredRecords.length < 1);

      const pagesCounter = getPagesCounter(response.data.results);
      this.usePagination(page, pagesCounter);
      this.isLoadingNow = false;
    },
    setJoins(url) {
      const joiningTables = [this.rowLinks, this.foreignKeyValues];
      joiningTables.forEach((tables) => {
        if (tables !== null) {
          for (let linkTable in tables) {
            url += `&join=${linkTable}s`;
          }
        }
      });
      return url;
    },
  },
  async mounted() {
    await this.getAllRecords();
  },
};
</script>

<style scoped>
.table__buttons {
  display: inline-flex;
  flex-direction: row;
}
.button_excel-doc {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/_shared/widgets/AllRecordsTable.vue